import { render } from "./BaseIconPagebreak.vue?vue&type=template&id=14361baa"
import script from "./BaseIconPagebreak.vue?vue&type=script&lang=js"
export * from "./BaseIconPagebreak.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseIconPagebreak.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "14361baa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('14361baa', __exports__)) {
    console.log('reload')
    api.reload('14361baa', __exports__)
  }
  
  module.hot.accept("./BaseIconPagebreak.vue?vue&type=template&id=14361baa", () => {
    console.log('re-render')
    api.rerender('14361baa', render)
  })

}


export default __exports__